


















































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import {
  both, includes, filter, sortBy, sortWith, prop, descend, ascend,
} from 'ramda'
import dayjs from 'dayjs'
import {
  getModule,
} from 'vuex-module-decorators'
import ViewUser from '../../components/users/ViewUser.vue'
import AddUser from '../../components/users/AddUser.vue'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import store from '../../store'
import UserStore from '../../store/modules/user'
import { UserType } from '../../types'
import CardList from '../../components/layout/CardList.vue'

// Filter Functions
const isActive = (user:UserType) => !(user.authTags && includes(`${store.getters.group}-inactive`, user.authTags))
const isInactive = (user:UserType) => (user.authTags && includes(`${store.getters.group}-inactive`, user.authTags))
const isManager = (user:UserType) => (user.authTags && includes(`${store.getters.group}-manager`, user.authTags))
const isEmployee = (user:UserType) => (user.authTags && !includes(`${store.getters.group}-manager`, user.authTags))
const isActiveManager = both(isActive, isManager)
const isActiveEmployee = both(isActive, isEmployee)
const sortByFirstNameAsc = sortWith([ascend(prop('firstName'))])
const sortByFirstNameDes = sortWith([descend(prop('firstName'))])
const sortByLastNameAsc = sortWith([ascend(prop('lastName'))])
const sortByLastNameDes = sortWith([descend(prop('lastName'))])
const sortByEmailAsc = sortWith([ascend(prop('email'))])
const sortByEmailDes = sortWith([descend(prop('email'))])

@Component({
  components: {
    ViewUser,
    AddUser,
    CardList,
  },
})

export default class Users extends Mixins(MainMixin) {
  get filterHeight() {
    if (!this.$refs.xfilters) return 1
    return this.$refs.xfilters.clientHeight
  }

  $refs:any

  scrollTop() {
    // window.scrollTo(0, document.body.scrollHeight / 2 - 200);
    console.log('x')
  }

  toggleFilter() {
    console.log('height is: ', this.$refs.xfilters.clientHeight)
    // this.filterHeight = Number(this.$refs.xfilters.clientHeight)
    this.showFilters = true
    console.log('height is: ', this.$refs.xfilters.clientHeight)
  }

  tabs = [{ title: 'View Users', value: 'view' }, { title: 'Add New', value: 'new' }]

  UserStore = getModule(UserStore)

  activeUser:UserType|{id: ''} = { id: '' }

  sort = { name: 'firstNameAsc', sortBy: sortByFirstNameAsc }

  filter = { name: 'active', filter: isActive }

  userSearchField = ''

  selectedUser = ''

  showFilters = false

  // Dynamic Filters

  sortList = [
    {
      text: 'First Name (A-Z)',
      value: { name: 'firstNameAsc', sortBy: sortByFirstNameAsc },
    },
    {
      text: 'First Name (Z-A)',
      value: { name: 'firstNameDec', sortBy: sortByFirstNameDes },
    },
    {
      text: 'Last Name (A-Z)',
      value: { name: 'lastNameAsc', sortBy: sortByLastNameAsc },
    },
    {
      text: 'Last Name (Z-A)',
      value: { name: 'lastNameDes', sortBy: sortByLastNameDes },
    },
    {
      text: 'Email (A-Z)',
      value: { name: 'emailAsc', sortBy: sortByEmailAsc },
    },
    {
      text: 'Email (Z-A)',
      value: { name: 'emailDes', sortBy: sortByEmailDes },
    },
  ]

  filterList = [
    {
      text: 'All Active Users',
      value: { name: 'active', filter: isActive },
    },
    {
      text: 'Active Employees',
      value: { name: 'activeEmployee', filter: isActiveEmployee },
    },
    {
      text: 'Active Managers',
      value: { name: 'activeManager', filter: isActiveManager },
    },
    {
      text: 'Inactive Users',
      value: { name: 'inactive', filter: isInactive },
    },
  ]

  get filteredUsers():UserType[]|[]|any {
    console.log('this.sorter is: ', this.sort.sortBy)
    return (this.sort.sortBy)(filter(this.filter.filter, this.UserStore.users))
  }

  showUser(x:string) {
    console.log('going', x)
    this.selectedUser = x
    this.activeUser = this.filteredUsers.find((user:UserType) => user.id === x)
  }

  @Watch('injectedData')
  onUserEmitted(user:string) {
    console.log('the user emiited is: ', user)
  }

  // created() {
  //   this.EventBus.$on('select-user', (id:string) => {
  //     console.log('going to activeuser: ', id)
  //   })
  // }
}
